import { GetListOperation, PostOperation } from '@/api/rest/base/operations';
import BaseApi from './base/BaseApi';

/**
 * Запрос КП. У дизайнера (ТЗ 4.1) — отправка позиций запроса на доработку; список запросов
 * спецификации живёт в SpecificationApi, это её подресурс. У поставщика (ТЗ 4.2) — «Мои запросы»
 * (коллекция ресурса), карточка запроса (`fetchItem`, первое открытие ставит «Просмотрен») и
 * отправка откликов. Сгенерировано Claude.
 */
export default class SpecRequestApi extends BaseApi {
  static entityName = 'spec_requests';

  /** На доработку: { items, comment } — одно уведомление поставщику (ТЗ 4.1). */
  rework(id, params, withPreloader = false) {
    const operation = new PostOperation(`${this.getIri(id)}/rework`, params);
    return this.execute(operation, withPreloader);
  }

  /** «Мои запросы» поставщика: только адресованные ему, без позиций (ТЗ 4.2). */
  fetchMine(withPreloader = false) {
    const operation = new GetListOperation(this.getIri());
    return this.execute(operation, withPreloader);
  }

  /**
   * Отправить отклики (ТЗ 4.2): без списка сервер берёт все черновики запроса, по которым отправка
   * разрешена статусом позиции. Ответ — карточка запроса.
   */
  sendOffers(id, offers = null, withPreloader = false) {
    const operation = new PostOperation(`${this.getIri(id)}/send_offers`, offers ? { offers } : {});
    return this.execute(operation, withPreloader);
  }
}
